import {
  query as publicQuery,
  queryExtendedBookings as publicQueryExtendedBookings,
  typedQueryExtendedBookings as publicTypedQueryExtendedBookings,
  countExtendedBookings as publicCountExtendedBookings,
} from './bookings-reader-v2-extended-booking-extended-bookings.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  ExtendedBookingQuery,
  ExtendedBookingsQueryBuilder,
  QueryExtendedBookingsOptions,
  typedQueryExtendedBookings as universalTypedQueryExtendedBookings,
} from './bookings-reader-v2-extended-booking-extended-bookings.universal.js';

function customQueryExtendedBookings(httpClient: HttpClient) {
  const router = /*#__PURE__*/ createQueryOverloadRouter({
    builderQueryFunction: (options?: QueryExtendedBookingsOptions) =>
      publicQueryExtendedBookings(httpClient)(options),
    typedQueryFunction: (
      query: ExtendedBookingQuery,
      options?: QueryExtendedBookingsOptions
    ) => publicTypedQueryExtendedBookings(httpClient)(query, options),
    hasOptionsParameter: true,
  });

  function overloadedQuery(
    query: ExtendedBookingQuery,
    options?: QueryExtendedBookingsOptions
  ): ReturnType<typeof universalTypedQueryExtendedBookings>;
  function overloadedQuery(
    options?: QueryExtendedBookingsOptions
  ): ExtendedBookingsQueryBuilder;
  function overloadedQuery(
    queryOrOptions?: ExtendedBookingQuery | QueryExtendedBookingsOptions,
    options?: QueryExtendedBookingsOptions
  ): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const query: MaybeContext<
  BuildRESTFunction<typeof publicQuery> & typeof publicQuery
> = /*#__PURE__*/ createRESTModule(publicQuery);
export const countExtendedBookings: MaybeContext<
  BuildRESTFunction<typeof publicCountExtendedBookings> &
    typeof publicCountExtendedBookings
> = /*#__PURE__*/ createRESTModule(publicCountExtendedBookings);
export const queryExtendedBookings: MaybeContext<
  BuildRESTFunction<typeof customQueryExtendedBookings> &
    typeof customQueryExtendedBookings
> = /*#__PURE__*/ createRESTModule(customQueryExtendedBookings);

export {
  DeferredChargeStatus,
  DeferredChargeDeclineReason,
  AttendanceStatus,
  MultiServiceBookingType,
  ResourceTransparency,
  LocationType,
  SelectionMethod,
  RequestedGender,
  DurationUnitType,
  ValueType,
  BookingStatus,
  PaymentStatus,
  SelectedPaymentOption,
  Platform,
  Actor,
  IdentityType,
  BookingFeeStatus,
  OrderStatus,
  PaymentStatusEnumPaymentStatus,
  Status,
  Frequency,
  SubscriptionStatus,
  SortOrder,
  SortType,
  SortDirection,
  MissingValues,
  ScalarType,
  Interval,
  NestedAggregationType,
  AggregationType,
  Mode,
  CommonScalarType,
  CommonAggregationType,
} from './bookings-reader-v2-extended-booking-extended-bookings.universal.js';
export {
  ExtendedBooking,
  Booking,
  BookingParticipantsInfoOneOf,
  BookedEntity,
  BookedEntityItemOneOf,
  BookedSlot,
  BookedResource,
  Location,
  PhoneCall,
  ResourceSelection,
  RequestedGenderValue,
  BookedSchedule,
  ContactDetails,
  Address,
  AddressStreetOneOf,
  StreetAddress,
  AddressLocation,
  Subdivision,
  CustomFormField,
  BookingSource,
  ParticipantNotification,
  IdentificationData,
  IdentificationDataIdOneOf,
  FlowControlSettings,
  ExtendedFields,
  ParticipantChoices,
  ServiceChoices,
  ServiceChoice,
  ServiceChoiceChoiceOneOf,
  Duration,
  DateTimeRule,
  ParticipantsRange,
  MultiServiceBookingInfo,
  BookedAddOn,
  ZonedDate,
  AllowedActions,
  Attendance,
  ConferencingDetails,
  BookingPolicySettings,
  BookingFeeDetails,
  Order,
  Price,
  PriceDescription,
  Balance,
  AdditionalFee,
  CouponInfo,
  Waiver,
  OrderTransactions,
  MembershipPaymentDetails,
  MembershipName,
  MembershipPaymentCredits,
  FormSubmission,
  SubscriptionInfo,
  CyclePrice,
  DeferredChargeInfo,
  DeferredChargeInfoStatusDetailsOneOf,
  QueryExtendedBookingRequest,
  QueryV2,
  QueryV2PagingMethodOneOf,
  Sorting,
  CommonAddressLocation,
  Paging,
  CursorPaging,
  QueryExtendedBookingResponse,
  PagingMetadataV2,
  Cursors,
  QueryExtendedBookingsRequest,
  CommonQueryV2,
  CommonQueryV2PagingMethodOneOf,
  CommonPaging,
  QueryExtendedBookingsResponse,
  CountExtendedBookingsRequest,
  CountExtendedBookingsResponse,
  SearchExtendedBookingsRequest,
  CursorSearch,
  CursorSearchPagingMethodOneOf,
  Aggregation,
  AggregationKindOneOf,
  RangeBucket,
  IncludeMissingValuesOptions,
  ValueAggregation,
  ValueAggregationOptionsOneOf,
  RangeAggregation,
  ScalarAggregation,
  DateHistogramAggregation,
  NestedAggregationItem,
  NestedAggregationItemKindOneOf,
  NestedAggregation,
  GroupByAggregation,
  GroupByAggregationKindOneOf,
  SearchDetails,
  SearchExtendedBookingsResponse,
  CursorPagingMetadata,
  AggregationData,
  ValueAggregationResult,
  RangeAggregationResult,
  NestedAggregationResults,
  NestedAggregationResultsResultOneOf,
  ValueResults,
  RangeResults,
  AggregationResultsScalarResult,
  NestedValueAggregationResult,
  ValueResult,
  RangeResult,
  ScalarResult,
  ScalarDateResult,
  NestedResultValue,
  NestedResultValueResultOneOf,
  Results,
  DateHistogramResult,
  GeotileGridBucket,
  GroupByValueResults,
  DateHistogramResults,
  NestedResults,
  AggregationResultsScalarDateResult,
  GeotileGridResults,
  AggregationResults,
  AggregationResultsResultOneOf,
  QueryOptions,
  QueryExtendedBookingsOptions,
  ExtendedBookingsQueryResult,
  ExtendedBookingsQueryBuilder,
  ExtendedBookingQuerySpec,
  CountExtendedBookingsOptions,
} from './bookings-reader-v2-extended-booking-extended-bookings.universal.js';
export { utils } from './bookings-reader-v2-extended-booking-extended-bookings.universal.js';
export {
  DeferredChargeStatusWithLiterals,
  DeferredChargeDeclineReasonWithLiterals,
  AttendanceStatusWithLiterals,
  MultiServiceBookingTypeWithLiterals,
  ResourceTransparencyWithLiterals,
  LocationTypeWithLiterals,
  SelectionMethodWithLiterals,
  RequestedGenderWithLiterals,
  DurationUnitTypeWithLiterals,
  ValueTypeWithLiterals,
  BookingStatusWithLiterals,
  PaymentStatusWithLiterals,
  SelectedPaymentOptionWithLiterals,
  PlatformWithLiterals,
  ActorWithLiterals,
  IdentityTypeWithLiterals,
  BookingFeeStatusWithLiterals,
  OrderStatusWithLiterals,
  PaymentStatusEnumPaymentStatusWithLiterals,
  StatusWithLiterals,
  FrequencyWithLiterals,
  SubscriptionStatusWithLiterals,
  SortOrderWithLiterals,
  SortTypeWithLiterals,
  SortDirectionWithLiterals,
  MissingValuesWithLiterals,
  ScalarTypeWithLiterals,
  IntervalWithLiterals,
  NestedAggregationTypeWithLiterals,
  AggregationTypeWithLiterals,
  ModeWithLiterals,
  CommonScalarTypeWithLiterals,
  CommonAggregationTypeWithLiterals,
  CommonQueryWithEntityContext,
  ExtendedBookingQuery,
} from './bookings-reader-v2-extended-booking-extended-bookings.universal.js';
